// Webpack Imports
import * as bootstrap from 'bootstrap';
var $ = jQuery.noConflict();

( function () {
	'use strict';
	var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
	var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
		return new bootstrap.Tooltip(tooltipTriggerEl, {
			trigger: 'mouseover',
		})
	})

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call( document.querySelectorAll( '[data-bs-toggle="popover"]' ) );
	var popoverList = popoverTriggerList.map( function ( popoverTriggerEl ) {
		return new bootstrap.Popover( popoverTriggerEl, {
			trigger: 'focus',
		} );
	} );
} )();

$(document).on('ready', function() {
	$('.simplefavorite-button').attr('data-bs-toggle', 'tooltip');
	$('.simplefavorite-button').attr('data-bs-placement', 'top');
	$('.simplefavorite-button').prop('title', 'Ajouter à mon menu personnalisé');
});